import { render, staticRenderFns } from "./airCargoTerminal.vue?vue&type=template&id=2432f673&"
import script from "./airCargoTerminal.vue?vue&type=script&lang=js&"
export * from "./airCargoTerminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2432f673')) {
      api.createRecord('2432f673', component.options)
    } else {
      api.reload('2432f673', component.options)
    }
    module.hot.accept("./airCargoTerminal.vue?vue&type=template&id=2432f673&", function () {
      api.rerender('2432f673', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/airCargoTerminal.vue"
export default component.exports